<template>
  <div class="account container-fluid">

    <div class="bind-and-change-pwd">
      <h2>{{ $t('settings') }}</h2>
      <bind></bind>
      <change-password class="change-pwd"></change-password>
    </div>

    <div class="subscription">
      <subscription></subscription>
    </div>

  </div>
</template>

<script>
  import Bind from '../../components/account/bind/Index.vue'
  import Subscription from '../../components/account/subscription/Index.vue'
  import ChangePassword from '../../views/safecenter/SafeCenter.vue'
  import locales from '../../components/leftSidebar/lang.js'
  export default {
    name: 'account',
    locales,
    components: {
      Bind, Subscription, ChangePassword
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
    border: 0;
  }

  h2 {
    display: none;
    @media screen and (max-width: 767px) {
      display: block;
      font-size: .24rem;
      line-height: 32px;
      color: #111111;
      font-weight: 600;
      text-align: center;
      margin-bottom: 0.24rem;
    }
  }

  .account {
    min-height: calc(100vh - 0.45rem - .3rem);
    color: #61687a;
    position: relative;
  }

  .subscription {
    background: #fff;
    border: 1px solid #E0D7E3;
    border-radius: 8px;
    @media screen and (max-width: 767px) {
      border-radius: 5px;
    }
  }

@mixin mobile-style() {
  .bind-and-change-pwd {
    margin-bottom: .24rem;
  }
  .change-pwd {
    margin-top: .24rem;
  }
  .bind-and-change-pwd, .subscription {
    clear: both;
    padding: 0;
    width: 100%;
    position: static;
    display: block;
  }
}

  @mixin pc-style() {
    .bind-and-change-pwd {
      width: 37%;
      float: left;
      padding-right: .24rem;
      .change-pwd {
        margin-top: .24rem;
      }
    }

    .subscription {
      position: absolute;
      width: (100% - 37%);
      top: 0;
      bottom: 0;
      right: 0;
    }
  }

  @mixin pad-style() {
    @include pc-style();
    .bind-and-change-pwd, .subscription {
      width: 50%;
    }
  }

  @media (max-width: 767px) {
    @include mobile-style();
  }

  @media (min-width: 768px) {
    @include pc-style();
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    @include mobile-style();
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    @include pad-style();
  }

  @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) {
    @include pad-style();
  }

</style>



// WEBPACK FOOTER //
// Settings.vue?41fe978d